import React, { useState, useEffect } from "react";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { IconButton } from "@mui/material";
import ViewSampleCheckinSheet from "./orders/ViewSampleCheckinSheet";
import { GetVlpReports } from "../../services/ReportSettingsService";
import { NotificationManager } from "react-notifications";
import CommonLoader from "../common/CommonLoader";
import AdminReports from "./AdminReports";
import LabReports from "./LabReports";
import { useNavigate } from "react-router-dom";
import UserService from "../../../globel-constants/UserService";

export default function Reports() {
  const [activeTab, setActiveTab] = useState("Lab");
  const [reportsData, setReportsData] = useState([]);
  const [adminReportsData, setAdminReportsData] = useState([]);
  const [orderReportsData, setOrderReportsData] = useState([]);
  const [othersReportsData, setOthersReportsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    let user = UserService.getUserInfoFromLocalStorage();
    setLoggedInUser(user);
    const fetchReports = async () => {
      try {
        setLoading(true);
        const response = await GetVlpReports();
        // Filter reports for Admin and Lab
        const adminReports = response.results.filter(
          (report) => report.reportType === "ADMIN"
        );
        const orderReports = response.results.filter(
          (report) => report.reportType === "LAB"
        );
        const othersReports = response.results.filter(
          (report) => report.reportType !== "LAB" && report.reportType !== "ADMIN"
        );
        // Update the state with filtered reports
        setAdminReportsData(adminReports);
        setOrderReportsData(orderReports);
        setOthersReportsData(othersReports)
        // Set all reports data (if needed)
        setReportsData(response.results);
      } catch (error) {
        NotificationManager.error(
          "Error fetching reports from the API: ",
          error
        );
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab == "Admin" && !loggedInUser.isReportAdmin) {
      navigate(`/vlp/unauthorized`);
    }
  };

  return (
    <div className="vlp-component-container">
      <div className="tabs is-left">
        <ul>
          {["Lab", "Admin","Others"].map((tab) => (
            <li key={tab} className={activeTab === tab ? "is-active" : ""}>
              <a onClick={() => handleTabClick(tab)}>
                <IconButton aria-label="Tab" color="primary">
                  <AssessmentIcon />
                </IconButton>
                <span>{tab}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className="content">
        <div className="vlp-component-container">
          {/* Render content based on the activeTab */}
          {activeTab === "QC Reports" && (
            /* Replace with your component for Types */
            <div> QC Reports </div>
          )}
          {activeTab === "Admin" && <AdminReports reports={adminReportsData} />}
          {activeTab === "Lab" && (
            /* Replace with your component for Bottles  */
            <LabReports reports={orderReportsData} />
          )}
          {activeTab === "Others" && (
            /* Replace with your component for Bottles  */
            <LabReports reports={othersReportsData} />
          )}
        </div>
      </div>

      <CommonLoader loading={loading} />
    </div>
  );
}
